/**
 * This file is categorized as "Proprietary Framework Code"
 * and is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import {
	Row,
} from 'native-base';
import Pagination from './Pagination'

export default function PaginationToolbar(props) {
	const {
			Repository
		} = props;
	if (!Repository || !Repository.isPaginated) {
		return null;
	}
	return <Row
				w="100%"
				bg="trueGray.300"
				borderTopWidth={1}
				borderTopColor="trueGray.400"
				borderBottomWidth={1}
				borderBottomColor="trueGray.400"
			>
				<Pagination {...props}>
					{props.children}
				</Pagination>
			</Row>;
};
